module.exports = __webpack_public_path__ + "media/components/src/assets/images/menu_1-179b12deb0d780e1cad0efedb9b5f49f.jpg";